/**
 * Geico Frame icons overrides, only usable from @gds/web-components in components that allow frame icons
 */

:host([icontype="frame-vehicle"]),
:host([icon-type="frame-vehicle"]) {
  --vehicle-icon: "\e001";
}

:host([icontype="frame-motorcycle"]),
:host([icon-type="frame-motorcycle"]) {
  --motorcycle-icon: "\e002";
}

:host([icontype="frame-homeowner"]),
:host([icon-type="frame-homeowner"]) {
  --homeowner-icon: "\e003";
}

:host([icontype="frame-boat"]),
:host([icon-type="frame-boat"]) {
  --boat-icon: "\e004";
}

:host([icontype="frame-rv"]),
:host([icon-type="frame-rv"]) {
  --rv-icon: "\e005";
}

:host([icontype="frame-condo"]),
:host([icon-type="frame-condo"]) {
  --condo-icon: "\e006";
}

:host([icontype="frame-atv"]),
:host([icon-type="frame-atv"]) {
  --atv-icon: "\e007";
}

:host([icontype="frame-pet"]),
:host([icon-type="frame-pet"]) {
  --pet-icon: "\e008";
}

:host([icontype="frame-collectibles"]),
:host([icon-type="frame-collectibles"]) {
  --collectibles-icon: "\e009";
}

:host([iconType="frame-geico"]),
:host([icon-type="frame-geico"]) {
  --geico-icon: "\e010";
}

:host([icontype*="frame-"]),
:host([icon-type*="frame-"]) {
  --icon-xsmall-dimensions: 5.6rem;
  --icon-small-dimensions: 5.6rem;
  --icon-medium-dimensions: 5.6rem;
  --icon-large-dimensions: 5.6rem;
  --icon-xlarge-dimensions: 5.6rem;
}
